<script>
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724797';
    export let message;

    export let type = '';

    function close() {
        messages.close(message.id);
    }

    function get_content(message) {
        if (Array.isArray(message)) {
            return message.join('<br>');
        }
        if (typeof message === 'string') {
            return message;
        }
        console.warn('unknown message', message);
        return '';
    }

    $: content = get_content(message.message);
</script>

{#if content}
    <div class="m-message {type}">
        <div class="m-message__icon">
            {#if message.type === 'success'}
                <i class="ri-check-line" />
            {:else if message.type === 'error'}
                <i class="ri-close-circle-line" />
            {:else if message.type === 'info'}
                <i class="ri-information-line" />
            {:else if message.type === 'warning'}
                <i class="ri-error-warning-line" />
            {/if}
        </div>
        <div class="m-message__message">{@html content}</div>
        <div class="m-message__button">
            <button class="btn btn--small" aria-label={window.__('shop.close')} on:click={close}
                ><i class="icon-close" />
                <span class="m-button__progress" style="--module-button-progress-percent: 1;" /></button
            >
        </div>
    </div>
{/if}


<style>
    .m-message__message {
        width: auto !important;
    }

    .m-message__icon {
        display: flex;
        align-items: center;
        width: auto !important;
    }

    .m-message__button {
        width: auto !important;
    }

    .m-message__message > :global(a) {
        font-size: var(--font-size__xs);
        color: var(--color-info-text);
    }
</style>